import React from 'react';
import PropTypes from 'prop-types';
import { View, Text } from '@react-pdf/renderer';

import { formatDate } from '../../../../helpers/formatters';

import { styles } from '../styles';

const Header = ({ dateRange, fileName, establishmentName }) => {
  const page = fileName.split('_').join(' ');

  return(
    <View>
      <Text style={styles.headerTitle}>
        {page}
      </Text>
      <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={styles.headerTitle}>
          Estabelecimento: {establishmentName}
        </Text>
        <Text style={styles.headerTitle}>
          {formatDate(dateRange[0])} - {formatDate(dateRange[1])}
        </Text>
      </View>
    </View>
  );
}

Header.propTypes = {
  dateRange: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  fileName: PropTypes.string.isRequired,
  establishmentName: PropTypes.string.isRequired
};

export default Header;